import sanitize from './sanitize'
import xssSanitize from './xssSanitize'

export default sanitize
export { xssSanitize }